// removed by extract-text-webpack-plugin
module.exports = {"li":"small-councis-module__li___2WERu","councilName":"small-councis-module__councilName___3rbl9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/small-council-list/small-councis.module.scss
// module id = 623
// module chunks = 0 1